var rootUrl = "https://content.s-cloud.fi/ds/";
var fonts = {
	GothamSSm: {
		"GothamSSm-BlackItalic_Web": {
			woff: {
				hash: "f99e7",
				fullPath: "fonts/GothamSSm/GothamSSm-BlackItalic_Web.f99e7.woff"
			},
			woff2: {
				hash: "5854b",
				fullPath: "fonts/GothamSSm/GothamSSm-BlackItalic_Web.5854b.woff2"
			}
		},
		"GothamSSm-Black_Web": {
			woff: {
				hash: "5fbe6",
				fullPath: "fonts/GothamSSm/GothamSSm-Black_Web.5fbe6.woff"
			},
			woff2: {
				hash: "2d55d",
				fullPath: "fonts/GothamSSm/GothamSSm-Black_Web.2d55d.woff2"
			}
		},
		"GothamSSm-BoldItalic_Web": {
			woff: {
				hash: "c67dd",
				fullPath: "fonts/GothamSSm/GothamSSm-BoldItalic_Web.c67dd.woff"
			},
			woff2: {
				hash: "dc473",
				fullPath: "fonts/GothamSSm/GothamSSm-BoldItalic_Web.dc473.woff2"
			}
		},
		"GothamSSm-Bold_Web": {
			woff: {
				hash: "956ec",
				fullPath: "fonts/GothamSSm/GothamSSm-Bold_Web.956ec.woff"
			},
			woff2: {
				hash: "c23a6",
				fullPath: "fonts/GothamSSm/GothamSSm-Bold_Web.c23a6.woff2"
			}
		},
		"GothamSSm-BookItalic_Web": {
			woff: {
				hash: "8416d",
				fullPath: "fonts/GothamSSm/GothamSSm-BookItalic_Web.8416d.woff"
			},
			woff2: {
				hash: "47e60",
				fullPath: "fonts/GothamSSm/GothamSSm-BookItalic_Web.47e60.woff2"
			}
		},
		"GothamSSm-Book_Web": {
			woff: {
				hash: "b0858",
				fullPath: "fonts/GothamSSm/GothamSSm-Book_Web.b0858.woff"
			},
			woff2: {
				hash: "e9b95",
				fullPath: "fonts/GothamSSm/GothamSSm-Book_Web.e9b95.woff2"
			}
		},
		"GothamSSm-LightItalic_Web": {
			woff: {
				hash: "89066",
				fullPath: "fonts/GothamSSm/GothamSSm-LightItalic_Web.89066.woff"
			},
			woff2: {
				hash: "e4e79",
				fullPath: "fonts/GothamSSm/GothamSSm-LightItalic_Web.e4e79.woff2"
			}
		},
		"GothamSSm-Light_Web": {
			woff: {
				hash: "d8d50",
				fullPath: "fonts/GothamSSm/GothamSSm-Light_Web.d8d50.woff"
			},
			woff2: {
				hash: "d7fbc",
				fullPath: "fonts/GothamSSm/GothamSSm-Light_Web.d7fbc.woff2"
			}
		},
		"GothamSSm-MediumItalic_Web": {
			woff: {
				hash: "70e7b",
				fullPath: "fonts/GothamSSm/GothamSSm-MediumItalic_Web.70e7b.woff"
			},
			woff2: {
				hash: "0ff5a",
				fullPath: "fonts/GothamSSm/GothamSSm-MediumItalic_Web.0ff5a.woff2"
			}
		},
		"GothamSSm-Medium_Web": {
			woff: {
				hash: "ee684",
				fullPath: "fonts/GothamSSm/GothamSSm-Medium_Web.ee684.woff"
			},
			woff2: {
				hash: "d2d6a",
				fullPath: "fonts/GothamSSm/GothamSSm-Medium_Web.d2d6a.woff2"
			}
		},
		"GothamSSm-XLightItalic_Web": {
			woff: {
				hash: "3fccb",
				fullPath: "fonts/GothamSSm/GothamSSm-XLightItalic_Web.3fccb.woff"
			},
			woff2: {
				hash: "aa713",
				fullPath: "fonts/GothamSSm/GothamSSm-XLightItalic_Web.aa713.woff2"
			}
		},
		"GothamSSm-XLight_Web": {
			woff: {
				hash: "53cb7",
				fullPath: "fonts/GothamSSm/GothamSSm-XLight_Web.53cb7.woff"
			},
			woff2: {
				hash: "e6c47",
				fullPath: "fonts/GothamSSm/GothamSSm-XLight_Web.e6c47.woff2"
			}
		}
	},
	Joe182: {
		"Joe182-regular": {
			woff: {
				hash: "6b086",
				fullPath: "fonts/Joe182/Joe182-regular.6b086.woff"
			},
			woff2: {
				hash: "46e98",
				fullPath: "fonts/Joe182/Joe182-regular.46e98.woff2"
			}
		}
	},
	SBonus: {
		"SBonusUX-BoldItalic": {
			eot: {
				hash: "30753",
				fullPath: "fonts/SBonus/SBonusUX-BoldItalic.30753.eot"
			},
			ttf: {
				hash: "0498a",
				fullPath: "fonts/SBonus/SBonusUX-BoldItalic.0498a.ttf"
			},
			woff: {
				hash: "4e3b7",
				fullPath: "fonts/SBonus/SBonusUX-BoldItalic.4e3b7.woff"
			},
			woff2: {
				hash: "24a29",
				fullPath: "fonts/SBonus/SBonusUX-BoldItalic.24a29.woff2"
			}
		},
		"SBonusUX-ExtraboldItalic": {
			eot: {
				hash: "c97a8",
				fullPath: "fonts/SBonus/SBonusUX-ExtraboldItalic.c97a8.eot"
			},
			ttf: {
				hash: "85b6b",
				fullPath: "fonts/SBonus/SBonusUX-ExtraboldItalic.85b6b.ttf"
			},
			woff: {
				hash: "4675d",
				fullPath: "fonts/SBonus/SBonusUX-ExtraboldItalic.4675d.woff"
			},
			woff2: {
				hash: "f660f",
				fullPath: "fonts/SBonus/SBonusUX-ExtraboldItalic.f660f.woff2"
			}
		},
		"SBonusUX-LightItalic": {
			eot: {
				hash: "40643",
				fullPath: "fonts/SBonus/SBonusUX-LightItalic.40643.eot"
			},
			ttf: {
				hash: "e1569",
				fullPath: "fonts/SBonus/SBonusUX-LightItalic.e1569.ttf"
			},
			woff: {
				hash: "c39cd",
				fullPath: "fonts/SBonus/SBonusUX-LightItalic.c39cd.woff"
			},
			woff2: {
				hash: "ab6bb",
				fullPath: "fonts/SBonus/SBonusUX-LightItalic.ab6bb.woff2"
			}
		},
		"SBonusUX-MediumItalic": {
			eot: {
				hash: "827c4",
				fullPath: "fonts/SBonus/SBonusUX-MediumItalic.827c4.eot"
			},
			ttf: {
				hash: "e578d",
				fullPath: "fonts/SBonus/SBonusUX-MediumItalic.e578d.ttf"
			},
			woff: {
				hash: "3885a",
				fullPath: "fonts/SBonus/SBonusUX-MediumItalic.3885a.woff"
			},
			woff2: {
				hash: "f0589",
				fullPath: "fonts/SBonus/SBonusUX-MediumItalic.f0589.woff2"
			}
		},
		"SBonusUX-RegularItalic": {
			eot: {
				hash: "26b1b",
				fullPath: "fonts/SBonus/SBonusUX-RegularItalic.26b1b.eot"
			},
			ttf: {
				hash: "85709",
				fullPath: "fonts/SBonus/SBonusUX-RegularItalic.85709.ttf"
			},
			woff: {
				hash: "c07c1",
				fullPath: "fonts/SBonus/SBonusUX-RegularItalic.c07c1.woff"
			},
			woff2: {
				hash: "9c225",
				fullPath: "fonts/SBonus/SBonusUX-RegularItalic.9c225.woff2"
			}
		},
		"SBonusUXWEB-Bold": {
			eot: {
				hash: "4cb55",
				fullPath: "fonts/SBonus/SBonusUXWEB-Bold.4cb55.eot"
			},
			ttf: {
				hash: "050b0",
				fullPath: "fonts/SBonus/SBonusUXWEB-Bold.050b0.ttf"
			},
			woff: {
				hash: "94646",
				fullPath: "fonts/SBonus/SBonusUXWEB-Bold.94646.woff"
			},
			woff2: {
				hash: "58dc2",
				fullPath: "fonts/SBonus/SBonusUXWEB-Bold.58dc2.woff2"
			}
		},
		"SBonusUXWEB-Extrabold": {
			eot: {
				hash: "8b54b",
				fullPath: "fonts/SBonus/SBonusUXWEB-Extrabold.8b54b.eot"
			},
			ttf: {
				hash: "5bd0b",
				fullPath: "fonts/SBonus/SBonusUXWEB-Extrabold.5bd0b.ttf"
			},
			woff: {
				hash: "fc22f",
				fullPath: "fonts/SBonus/SBonusUXWEB-Extrabold.fc22f.woff"
			},
			woff2: {
				hash: "a7fc2",
				fullPath: "fonts/SBonus/SBonusUXWEB-Extrabold.a7fc2.woff2"
			}
		},
		"SBonusUXWEB-Light": {
			eot: {
				hash: "ad7a8",
				fullPath: "fonts/SBonus/SBonusUXWEB-Light.ad7a8.eot"
			},
			ttf: {
				hash: "09a8c",
				fullPath: "fonts/SBonus/SBonusUXWEB-Light.09a8c.ttf"
			},
			woff: {
				hash: "fd29e",
				fullPath: "fonts/SBonus/SBonusUXWEB-Light.fd29e.woff"
			},
			woff2: {
				hash: "6f7b2",
				fullPath: "fonts/SBonus/SBonusUXWEB-Light.6f7b2.woff2"
			}
		},
		"SBonusUXWEB-Medium": {
			eot: {
				hash: "5d456",
				fullPath: "fonts/SBonus/SBonusUXWEB-Medium.5d456.eot"
			},
			ttf: {
				hash: "f5dd9",
				fullPath: "fonts/SBonus/SBonusUXWEB-Medium.f5dd9.ttf"
			},
			woff: {
				hash: "09204",
				fullPath: "fonts/SBonus/SBonusUXWEB-Medium.09204.woff"
			},
			woff2: {
				hash: "3a125",
				fullPath: "fonts/SBonus/SBonusUXWEB-Medium.3a125.woff2"
			}
		},
		"SBonusUXWEB-Regular": {
			eot: {
				hash: "6edea",
				fullPath: "fonts/SBonus/SBonusUXWEB-Regular.6edea.eot"
			},
			ttf: {
				hash: "94cc6",
				fullPath: "fonts/SBonus/SBonusUXWEB-Regular.94cc6.ttf"
			},
			woff: {
				hash: "25940",
				fullPath: "fonts/SBonus/SBonusUXWEB-Regular.25940.woff"
			},
			woff2: {
				hash: "572f0",
				fullPath: "fonts/SBonus/SBonusUXWEB-Regular.572f0.woff2"
			}
		}
	},
	SBonusDisplay: {
		"SBonusDisplay-Black": {
			eot: {
				hash: "3e8b5",
				fullPath: "fonts/SBonusDisplay/SBonusDisplay-Black.3e8b5.eot"
			},
			woff: {
				hash: "7685f",
				fullPath: "fonts/SBonusDisplay/SBonusDisplay-Black.7685f.woff"
			},
			woff2: {
				hash: "ed9c4",
				fullPath: "fonts/SBonusDisplay/SBonusDisplay-Black.ed9c4.woff2"
			}
		},
		"SBonusDisplay-Bold": {
			eot: {
				hash: "fadeb",
				fullPath: "fonts/SBonusDisplay/SBonusDisplay-Bold.fadeb.eot"
			},
			woff: {
				hash: "45377",
				fullPath: "fonts/SBonusDisplay/SBonusDisplay-Bold.45377.woff"
			},
			woff2: {
				hash: "b9065",
				fullPath: "fonts/SBonusDisplay/SBonusDisplay-Bold.b9065.woff2"
			}
		},
		"SBonusDisplay-Light": {
			eot: {
				hash: "46a9b",
				fullPath: "fonts/SBonusDisplay/SBonusDisplay-Light.46a9b.eot"
			},
			woff: {
				hash: "d7ce6",
				fullPath: "fonts/SBonusDisplay/SBonusDisplay-Light.d7ce6.woff"
			},
			woff2: {
				hash: "35a24",
				fullPath: "fonts/SBonusDisplay/SBonusDisplay-Light.35a24.woff2"
			}
		},
		"SBonusDisplay-Medium": {
			eot: {
				hash: "5422c",
				fullPath: "fonts/SBonusDisplay/SBonusDisplay-Medium.5422c.eot"
			},
			woff: {
				hash: "52a9e",
				fullPath: "fonts/SBonusDisplay/SBonusDisplay-Medium.52a9e.woff"
			},
			woff2: {
				hash: "c219b",
				fullPath: "fonts/SBonusDisplay/SBonusDisplay-Medium.c219b.woff2"
			}
		},
		"SBonusDisplay-Regular": {
			eot: {
				hash: "b0174",
				fullPath: "fonts/SBonusDisplay/SBonusDisplay-Regular.b0174.eot"
			},
			woff: {
				hash: "5d8f9",
				fullPath: "fonts/SBonusDisplay/SBonusDisplay-Regular.5d8f9.woff"
			},
			woff2: {
				hash: "3be51",
				fullPath: "fonts/SBonusDisplay/SBonusDisplay-Regular.3be51.woff2"
			}
		},
		"SBonusDisplay-SemiBold": {
			eot: {
				hash: "eb876",
				fullPath: "fonts/SBonusDisplay/SBonusDisplay-SemiBold.eb876.eot"
			},
			woff: {
				hash: "86e47",
				fullPath: "fonts/SBonusDisplay/SBonusDisplay-SemiBold.86e47.woff"
			},
			woff2: {
				hash: "b9ddb",
				fullPath: "fonts/SBonusDisplay/SBonusDisplay-SemiBold.b9ddb.woff2"
			}
		}
	}
};

export { fonts, rootUrl };
//# sourceMappingURL=registry.json.js.map
